module.exports = __webpack_public_path__ + "static/medicamentos-materiais-91f09fe87cfcb165851e3e167202641f.jpg";